import { call, all } from 'redux-saga/effects';

import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';

import * as agendaService from '../page-storage/agenda-items/agenda-items.saga-services';
import * as meetingArchivesService from '../page-storage/meeting-archive/meeting-archive.saga-service';
import * as meetingShortcutsService from '../../resource/meeting-shortcuts/meeting-shortcuts.saga-service';

import * as kpiService from '../page-storage/kpi/kpi.saga-services';
import * as meetingTasksService from '../page-storage/meeting-tasks/meeting-tasks.saga-services';
import * as meetingBoardsService from '../page-storage/meeting-boards/meeting-boards.saga-services';
import * as annualsService from '../../resource/annuals/annuals.saga-service';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import {
  ICreateMeetingFolder,
  ICreateMeetingShortcut,
  IMeetingFolder,
  IMeetingShortcut,
  IMeetingSubFolder,
  IUpdateMeetingShortcut,
} from '../../resource/meeting-shortcuts/meeting-shortcuts.types';
import { IMeeting } from '../../resource/meeting/meeting.types';
import { annualsSelectors } from '../../resource/annuals/annuals.selectors';
import { select } from '../../../utils/selector.utils';
import { IAnnual } from '../../resource/annuals/annuals.types';
import * as wrikeFolderService from '../../resource/wrike-folder/wrike-folder.saga-service';
import * as wrikeFolderMeetingService from '../../resource/wrike-folder-meeting/wrike-folder-meeting.saga-service';
import * as settingsService from '../../resource/settings/settings.saga-service';

export function* initialMeetingDashboardPage(meetingId: IMeetingSimple['id']) {
  if (!meetingId) {
    return;
  }
  //yield call(agendaService.clearAgendaItemsPageStorage);
  yield call(pageStateService.initPage, 'meetingDashboard');

  if (!((yield call(pageInitializerService.initPage)) as boolean)) {
    // Check if annuals are already fetched (this is just a selector read, very fast)
    const isFetched = !!((yield select(annualsSelectors.selectResourceList)) as IAnnual[]).length;

    // Run all independent API calls in parallel
    const parallelCalls: ReturnType<typeof call>[] = [
      call(meetingShortcutsService.getShorcutFoldersAndUnSelectedMeetingShortcutsFolder, meetingId),
      call(kpiService.setupKpi, meetingId),
      call(meetingBoardsService.setupMeetingBoards, meetingId),
      call(meetingTasksService.setupMeetingTasks, meetingId),
      call(meetingArchivesService.fetchMeetingArchives, meetingId, {}),
      call(settingsService.searchSettings),
      call(agendaService.getAgendaItems, meetingId),
      call(wrikeFolderService.fetchWrikeFolders),
      call(wrikeFolderMeetingService.fetchWrikeFolderMeetings),
    ];

    // Conditionally add annuals if not already fetched
    if (!isFetched) {
      parallelCalls.push(call(annualsService.getAnnuals));
    }

    yield all(parallelCalls);
  }

  yield call(pageStateService.completedInit, 'meetingDashboard');
}

// create new folder
export function* teamFileCreateFolderMeetingDashboardPage(
  meetingId: ICreateMeetingFolder['meetingId'],
  name: ICreateMeetingFolder['name'],
  parentId?: ICreateMeetingFolder['parentId'],
) {
  yield call(meetingShortcutsService.createFileFolder, meetingId, name, parentId);
}

// create new file
export function* teamFileCreateFileMeetingDashboardPage(
  meetingId: ICreateMeetingFolder['meetingId'],
  externalLink: ICreateMeetingShortcut['externalLink'],
  description: ICreateMeetingShortcut['description'],
  folderId: ICreateMeetingShortcut['folderId'],
  name: ICreateMeetingShortcut['name'],
) {
  yield call(meetingShortcutsService.createFileFolderFile, meetingId, externalLink, description, folderId, name);
}

// update shortcut
export function* meetingShortcutUpdate(
  shortcutId: IUpdateMeetingShortcut['shortcutId'],
  meetingId: IUpdateMeetingShortcut['meetingId'],
  externalLink: IUpdateMeetingShortcut['externalLink'],
  description: IUpdateMeetingShortcut['description'],
  name: IUpdateMeetingShortcut['name'],
) {
  yield call(meetingShortcutsService.updateShortcut, meetingId, shortcutId, externalLink, description, name);
}

// update shortcut
export function* meetingShortcutDelete(shortcutId: IMeetingShortcut['id'], meetingId: IMeetingSimple['id']) {
  yield call(meetingShortcutsService.deleteShortcut, meetingId, shortcutId);
}

// selection folder
export function* teamFileSelectionFolderMeetingDashboardPage(
  meetingId: ICreateMeetingFolder['meetingId'],
  folder: IMeetingFolder | IMeetingSubFolder,
) {
  yield call(meetingShortcutsService.setSelectedMeetingShortcutsFolder, meetingId, folder);
}

// delete file folder
export function* teamFilesDeleteFileMeetingDashboardPage(
  meetingId: ICreateMeetingFolder['meetingId'],
  fileFolderId: IMeetingShortcut['id'],
) {
  yield call(meetingShortcutsService.deleteFileFolder, meetingId, fileFolderId);
}

export function* teamFileUnSelectionFolderMeetingDashboardPage(meetingId: IMeeting['id']) {
  yield call(meetingShortcutsService.getShorcutFoldersAndUnSelectedMeetingShortcutsFolder, meetingId);
}
